import { useMemo } from 'react';
import useCategory from './useCategory';
export default function useArticles(categoryId) {
    const category = useCategory(categoryId);
    const value = useMemo(() => {
        let _category;
        if (category) {
            _category = category;
        }
        else {
            throw new Error('not sure what category to look up in useArticles....');
        }
        return {
            articles: _category.articles.results.map((a) => ({
                ...a,
                categoryId: _category.id,
            })),
            totalCount: _category.articles.pageInfo.totalCount,
        };
    }, [category]);
    return value;
}
//# sourceMappingURL=useArticles.js.map